<script lang="ts">

import { Character, characterStore, initCharacter } from "../character/character";
import { calcLevel } from "../groups/group";
import LevelInput from "../levelup/LevelInput.svelte";
import { calculateSpells } from "./spells";

let character: Character = initCharacter();

characterStore.subscribe(chara => {
	character = chara
	character.spellLists = calculateSpells(character);
})


</script>

	<h2>Sprüche</h2>
	<div
		class="
		grid
		grid-cols-1 gap-4
		sm:grid-cols-1
		lg:grid-cols-1
		xl:grid-cols-2
		2xl:grid-cols-2
		"
	>
		{#each character.spellLists as spelllist}


			<div class="border border-gray-300 rounded-md bg-gray-100 p-2">
				<strong>
					{spelllist.id} - {spelllist.name}
				
				</strong>


				<div class="grid grid-cols-2 gap-4">

					<input type="number"
									
									on:change="{() => {
		
										characterStore.set(character)
									}}"
									bind:value={spelllist.points}>
					
					
					<div>
						{spelllist.rank}
					</div>
	
					<div class="col-span-2">
						<table>
							{#each spelllist.spells as spell}
								{#if spell.level <= spelllist.points}
								<tr class="odd:bg-white even:bg-slate-50">
									<td class="p-4">{spell.level}</td>
									<td class="p-4">{spell.name}</td>
									<td>{spell.value}</td>
								</tr>
								{/if}
							{/each}
					</table>
					
				</div>
				</div>

			</div>	
		{/each}

	</div>

	<!--
			<table>
			<th>ID</th>
			<th>Name</th>
			<th>Punkte</th>
			<th>Rang</th>

				{#each character.spellLists as spelllist}

					<tr>
						<td>{spelllist.id}</td>
						<td>{spelllist.name}</td>
						<td>
							<input type="number"
								
								on:change="{() => {
	
									characterStore.set(character)
								}}"
								bind:value={spelllist.points}>
								
						</td>
						<td>
							{spelllist.rank}
						</td>
					</tr>

					{#each spelllist.spells as spell}
						{#if spell.level <= spelllist.points}
							<tr>
								<td>{spell.level}</td>
								<td>{spell.name}</td>
								<td>{spell.value}</td>
							</tr>
						{/if}
					{/each}
				{/each}

		</table>
	-->

